module.exports = __webpack_public_path__ + "img/3.e1d0c64b.png";